// Presentation-only status badge that consumers use everywhere a voucher
// appears — list rows, detail hero, redemption log, and create preview.

import { Badge } from '@bbpos/ui';
import type { VoucherStatus } from './types';
import { statusMeta } from './status';

export interface VoucherStatusPillProps {
  status: VoucherStatus;
  size?: 'sm' | 'md';
}

export function VoucherStatusPill({ status, size = 'sm' }: VoucherStatusPillProps) {
  const meta = statusMeta(status);
  return (
    <Badge variant={meta.badgeVariant} size={size}>
      <span className="flex items-center gap-1.5">
        <span className="h-1.5 w-1.5 rounded-full bg-current" />
        {meta.label}
      </span>
    </Badge>
  );
}
